/**
 * @generated SignedSource<<ee28bd0c1cb3fc500b2dec8a1e78f93d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type historyNoteQuery$variables = {
  lastSeen: string;
  noteId: string;
  queryLastSeen: boolean;
};
export type historyNoteQuery$data = {
  readonly node: {
    readonly createdAt?: string | null;
    readonly id?: string;
    readonly proseTransactionBetween?: {
      readonly contributors: ReadonlyArray<{
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
      }>;
      readonly createdAt: string;
      readonly docs: ReadonlyArray<any>;
      readonly id: string;
      readonly numSteps: number;
      readonly startVersion: number;
      readonly updatedAt: string;
    } | null;
    readonly proseTransactions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly contributors: ReadonlyArray<{
            readonly email: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
          }>;
          readonly createdAt: string | null;
          readonly id: string;
          readonly numSteps: number;
          readonly startVersion: number;
          readonly updatedAt: string | null;
        } | null;
      } | null>;
    } | null;
    readonly version?: number;
  } | null;
};
export type historyNoteQuery = {
  response: historyNoteQuery$data;
  variables: historyNoteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastSeen"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryLastSeen"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startVersion",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numSteps",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v11 = {
  "condition": "queryLastSeen",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "startDateTime",
          "variableName": "lastSeen"
        }
      ],
      "concreteType": "CombinedProseTransaction",
      "kind": "LinkedField",
      "name": "proseTransactionBetween",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "docs",
          "storageKey": null
        },
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ]
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "ProseTransactionConnection",
  "kind": "LinkedField",
  "name": "proseTransactions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProseTransactionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProseTransaction",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v8/*: any*/),
            (v7/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "historyNoteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "historyNoteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v12/*: any*/),
              (v11/*: any*/)
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fee5540717548e17873f93bbab8fbcfb",
    "id": null,
    "metadata": {},
    "name": "historyNoteQuery",
    "operationKind": "query",
    "text": "query historyNoteQuery(\n  $noteId: ID!\n  $lastSeen: DateTime!\n  $queryLastSeen: Boolean!\n) {\n  node(id: $noteId) {\n    __typename\n    ... on Note {\n      id\n      createdAt\n      version\n      proseTransactionBetween(startDateTime: $lastSeen) @include(if: $queryLastSeen) {\n        id\n        docs\n        startVersion\n        numSteps\n        contributors {\n          id\n          fullName\n          image\n          email\n        }\n        updatedAt\n        createdAt\n      }\n      proseTransactions {\n        edges {\n          node {\n            id\n            numSteps\n            startVersion\n            contributors {\n              id\n              fullName\n              image\n              email\n            }\n            updatedAt\n            createdAt\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "59a7cd743b6d505224d59cdc74cd7c44";

export default node;
